import { render, staticRenderFns } from "./treatment-overview-pdf.vue?vue&type=template&id=1981e23f&"
import script from "./treatment-overview-pdf.vue?vue&type=script&lang=js&"
export * from "./treatment-overview-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports